import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import type from "./constants/types";
import request from "@/service";
import Cookies from "js-cookie";
import router from "@/router";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("./views/Login"),
      async beforeEnter(to, from, next) {
        if (to.query.codex && localStorage.getItem("token")) {
          const response = await request("GET", `users/verify?id=${to.query.id}&codex=${to.query.codex}`);
          let params = {};
          if (response) {
            params = { activation: true };
          }
          next({
            name: "Home",
            params: params,
          });
        } else if (window.localStorage.getItem("token")) {
          let token = Cookies.get("token");
          if (!token) {
            Cookies.set("token", window.localStorage.getItem("token").replace("Bearer ", ""), { expires: 30 });
          }
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/forgotpassword",
      name: "ForgotPassword",
      component: () => import("./views/ForgotPassword"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next("/");
        } else {
          next({
            name: to,
          });
        }
      },
    },
    {
      path: "/changepassword",
      name: "ChangePassword",
      component: () => import("./views/ChangePassword"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/onboard",
      name: "Onboard",
      component: () => import("./views/Onboardv4"),
      async beforeEnter(to, from, next) {
        if (!["http://localhost:8080", "https://dev.weezly.com", "https://app.weezly.com"].includes(location.origin)) {
          location.href = "https://app.weezly.com/onboard";
          return;
        } else if (window.localStorage.getItem("token")) {
          next("/");
        } else {
          const response = await request("GET", "admin/getOnboardVersion");

          if (response && response.data == "v4") {
            const Onboardv4 = (await import("./views/Onboardv4")).default;
            to.matched[0].components.default = Onboardv4;
          } else {
            const Onboardv3 = (await import("./views/Onboardv3")).default;
            to.matched[0].components.default = Onboardv3;
          }

          next();
        }
      },
    },

    {
      path: "/",
      alias: ["/bookingpage", "/timeslotpicker", "/groupinvite", "/widget"],
      name: "Home",
      component: () => import("@/views/Scheduling"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          let menu = localStorage.getItem("menu");
          if (menu && menu != "/" && (from.name == null) | (from.name == "Login")) {
            next(menu);
          } else {
            next();
          }
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/bookingpage/:ID",
      name: "Booking page",
      component: () => import("@/views/Scheduling"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/timeslotpicker/:ID",
      name: "Timeslot picker",
      component: () => import("@/views/Scheduling"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/groupinvite/:ID",
      name: "Group invite",
      component: () => import("@/views/Scheduling"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/widget/:ID",
      name: "Website widget",
      component: () => import("@/views/Scheduling"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/settings",
      name: "Settings",
      component: () => import("@/components/Scheduling/Settings/Settings"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/settings/:tabID",
      name: "Setting",
      component: () => import("@/components/Scheduling/Settings/Settings"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/availability",
      name: "Availability",
      component: () => import("@/components/Scheduling/Availability/Availability"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/scheduled-events",
      name: "Scheduled",
      component: () => import("@/components/Scheduling/Schedule/Schedule"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/integrations",
      name: "Integrations",
      component: () => import("@/components/Scheduling/Integrations/Integrations"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/integrations/:appID",
      name: "Integration",
      component: () => import("@/components/Scheduling/Integrations/Integrations"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          localStorage.setItem("history_url", to.path);
          next("/login");
        }
      },
    },
    {
      path: "/calendar-connections",
      name: "Calendar connections",
      component: () => import("@/components/Scheduling/Connection/Connection"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/analytics",
      name: "Analytics",
      component: () => import("@/components/Scheduling/Analytics/Analytics"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/upgrade",
      name: "Upgrade",
      component: () => import("@/views/Upgrade"),
      beforeEnter(to, from, next) {
        if (!["http://localhost:8080", "https://dev.weezly.com", "https://app.weezly.com"].includes(location.origin)) {
          location.href = "https://app.weezly.com/onboard";
          return;
        } else if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/payment-success",
      name: "Payment Success",
      component: () => import("@/views/PaymentSuccess"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/screencast",
      name: "Screencast",
      component: () => import("@/components/Scheduling/Videos/Videos"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/screencast/upload",
      name: "Screencast upload",
      component: () => import("@/components/Scheduling/Videos/Upload"),
    },
    {
      path: "/screencast/:videoID",
      name: "Screencast video",
      component: () => import("@/components/Scheduling/Videos/Video"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/externaltimeslot",
      name: "External Timeslot",
      component: () => import("@/views/ExternalTimeslot"),
    },
    {
      path: "/dynamic-videos",
      alias: ["/create-dynamic-videos"],
      name: "Dynamic videos",
      component: () => import("@/views/DynamicVideos"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/dynamic-videos/campaigns/:campaignID",
      name: "Dynamic campaigns",
      component: () => import("@/components/Dynamic/Campaign/CampaignView"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/dynamic-videos/folder/:folderID",
      name: "Dynamic campaigns",
      component: () => import("@/views/DynamicVideos"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/dynamic-videos/:videoID",
      name: "Dynamic video",
      component: () => import("@/components/Dynamic/DynamicPage"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/external-dynamic",
      name: "External Dynamic Video",
      component: () => import("@/views/ExternalDynamic"),
    },
    {
      path: "/external-dynamic-campaign",
      name: "External Dynamic Campaign",
      component: () => import("@/views/ExternalDynamicCampaign"),
    },
    {
      path: "/weezly2023tool",
      name: "Tool",
      component: () => import("@/views/Tool"),
    },
    {
      path: "/tuan",
      name: "Tuan",
      component: () => import("@/views/Tuan"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/create-video-embed",
      name: "Create Video Embed",
      component: () => import("@/views/CreateVideoEmbed"),
    },
    {
      path: "/request-calendar",
      name: "Request Calendar",
      component: () => import("@/views/RequestCalendar"),
    },
    {
      path: "/weezly-users",
      name: "Weezly Users",
      component: () => import("@/views/WeezlyUsers"),
    },
    {
      path: "/try/:owner",
      name: "Affiliate",
      async beforeEnter(to, from, next) {
        const response = await request("GET", "users/getOwner?link=" + to.params.owner);
        if (response) {
          window.localStorage.setItem("referrer", to.params.owner);
        }
        window.location.href = "https://weezly.com";
      },
      // component: () => import("@/components/Scheduling/Booking/BookingList"),
    },
    {
      path: "/video_embed/:id",
      name: "Video embed",
      component: () => import("@/components/Scheduling/VideoEmbed/Booking"),
    },
    {
      path: "/organization/accept",
      name: "Accept invitation",
      async beforeEnter(to, from, next) {
        let key = to.query.key;
        const response = await request("POST", "organization/accept?key=" + key);
        if (response) {
          let status = response.data.status;

          if ((status == "new_register") | (status == "login")) {
            //  Logout
            window.localStorage.clear();
            sessionStorage.clear();
            Cookies.remove("me");
            Cookies.remove("id");
            Cookies.remove("vuex");
            Cookies.remove("lastLoaded");
            Cookies.remove("token");
            store.dispatch({
              type: "logout",
            });
          }

          if (status == "new_register") {
            next(`/onboard?email=${response.data.email}&accept_key=${response.data.accept_key}`);
          } else if (status == "login") {
            next(`/login?email=${response.data.email}&accept_key=${response.data.accept_key}`);
          } else {
            next("/");
          }
        } else {
          next("/");
        }
      },
    },
    {
      path: "/tutorials",
      alias: ["/tutorials/:categoryID", "/tutorials/:categoryID/:videoID"],
      name: "Tutorials",
      component: () => import("@/views/Tutorials"),
    },
    {
      path: "/clients",
      name: "Clients",
      component: () => import("@/views/Clients"),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem("token")) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/connect-client",
      name: "Connect Client",
      component: () => import("@/views/ConnectClient"),
    },
    {
      path: "/invite",
      name: "Invite",
      component: () => import("@/views/Invite"),
    },
    {
      path: "/:owner",
      name: "Booking List",
      beforeEnter: async (to, from, next) => {
        try {
          const { owner } = to.params;

          if (!["http://localhost:8080", "https://dev.weezly.com", "https://app.weezly.com"].includes(location.origin)) {
            const response = await request("GET", `users/checkOwnerByDomain`);
            if (response) {
              let link = response.data.link;
              if (link != owner) {
                to.meta.component = (await import("@/components/Scheduling/Booking/BookingRender")).default;
                to.params.owner = link;
                to.params.event = owner;
              }
            }
          }

          next();
        } catch (error) {
          next(false);
        }
      },
      component: () => import("@/components/Scheduling/Booking/BookingList"),
      meta: {
        component: null,
      },
    },
    {
      path: "/:owner/:event",
      name: "Booking",
      beforeEnter: async (to, from, next) => {
        try {
          const { owner, event } = to.params;

          if (!["http://localhost:8080", "https://dev.weezly.com", "https://app.weezly.com"].includes(location.origin)) {
            if (["hr_", "lgm_", "sl_", "il_", "rpl_"].some((prefix) => owner.startsWith(prefix))) {
              let url = location.origin;
              const checkDomain = await request("GET", `users/checkOwnerByDomain`);
              if (checkDomain) {
                let link = checkDomain.data.link;
                const response = await request("GET", `dynamic/link/getLink?owner=${link}&campaign_id=${owner}&lead_id=${event}`);
                if (response) {
                  url = response.data.url;
                  // url = url.replace(`/${link}/`, "/");
                }
              }
              location.href = url;
              return false;
            }
          }

          next();
        } catch (error) {
          next(false);
        }
      },
      component: () => import("@/components/Scheduling/Booking/BookingRender"),
    },
    {
      path: "/:owner/:campaign_id/:lead_id",
      name: "Booking",
      async beforeEnter(to, from, next) {
        let owner = to.params.owner;
        let campaign_id = to.params.campaign_id;
        let lead_id = to.params.lead_id;
        let url = location.origin;
        const response = await request("GET", `dynamic/link/getLink?owner=${owner}&campaign_id=${campaign_id}&lead_id=${lead_id}`);

        if (response) {
          url = response.data.url;
        }
        location.href = url;
      },
    },
  ],
});
